import React, { PureComponent } from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import ReactSpeedometer from "react-d3-speedometer"

const RADIAN = Math.PI / 180;
const cx = 50;
const cy = 45;
const iR = 30;
const oR = 10;
// const value = 55;

const needle = (value, data, cx, cy, iR, oR, color) => {
  let total = 0;
  data.forEach((v) => {
    total += v.value;
  });
  const ang = 180.0 * (1 - value / total);
  const length = (iR + 2 * oR) / 3;
  const sin = Math.sin(-RADIAN * ang);
  const cos = Math.cos(-RADIAN * ang);
  const r = 5;
  const x0 = cx + 5;
  const y0 = cy + 5;
  const xba = x0 + r * sin;
  const yba = y0 - r * cos;
  const xbb = x0 - r * sin;
  const ybb = y0 + r * cos;
  const xp = x0 + length * cos;
  const yp = y0 + length * sin;

  return [
    <circle cx={x0} cy={y0} r={r} fill={color} stroke="none" />,
    <path d={`M${xba},${yba}L${xbb},${ybb},L${xp},${yp},L${xba},${yba}`} stroke="#none" fill={color} />,
  ];
};
export const WithNeedleChart = ({value, width = 100, height = 80}) => {
  return <PieChart
    width={width}
    height={height}>
    <Pie
      dataKey="value"
      startAngle={180}
      endAngle={0}
      data={newArray}
      cx={cx}
      cy={45}
      width={width}
      height={height}
      // innerRadius={iR}
      // outerRadius={oR}
      fill="#8884d8"
      stroke="none"
    >
      {newArray.map((entry, index) => (
        <Cell key={`cell-${index}`} dataKey="value" fill={entry.color} />
      ))}
    </Pie>
    {needle(value, newArray, cx, cy, iR, oR, '#277f4a')}
  </PieChart>

}
const newArray = [
  { id: 0, label: 'Insustentável', color: '#c65c5e', value: 20 },
  { id: 1, label: 'Quase Insustentável', color: '#ef825d', value: 20 },
  { id: 2, label: 'Intermediário', color: '#f7c648', value: 20 },
  { id: 3, label: 'Quase Sustentável', color: '#d5e370', value: 20 },
  { id: 4, label: 'Sustentável', color: '#6aaa73', value: 20 },
]

export const BarometerChartComponent = ({ value, width = 100, height = 80, label, needleHeightRatio }) => {
  return <ReactSpeedometer
    value={value}
    maxValue={10000}
    currentValueText={label ? `Indice Geral de Sustentabilidade ${label}` : ""}
    maxSegmentLabels={!label && 0}
    customSegmentLabels={label && barometer}
    segmentColors={barometer.map(item => item.bgColor)}
    labelFontSize={"18px"}
    valueTextFontSize={!label && '0px'}
    needleTransitionDuration={4000}
    needleTransition="easeElastic"
    needleHeightRatio={needleHeightRatio}
    needleColor="#001C00"
    width={width}
    height={height}
  />

}
const barometer = [
  { id: 0, position: "INSIDE", text: 'Ruim', color: "white", bgColor: '#FF0101', value: 20 },
  { id: 1, position: "INSIDE", text: 'Pobre', color: "white",bgColor: '#FF8C02', value: 20 },
  { id: 2, position: "INSIDE", text: 'Intermédiário', color: "white",bgColor: '#FFCC03', value: 20 },
  { id: 3, position: "INSIDE", text: 'Bom', color: "white",bgColor: '#42A67C', value: 20 },
  { id: 4, position: "INSIDE", text: 'Ótimo', color: "white",bgColor: '#0B7348', value: 20 },
]


